export default "__VITE_ASSET__a8ac03fd__"